import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import blogService from '../services/blogServices';
import styles from '../style';

const BlogDetail = ({blogs}) => {
  const { id } = useParams(); // This gets the ID from URL
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (id) {
      loadBlog();
    }
  }, [id]);

  const loadBlog = () => {
    setLoading(true);
    const foundBlog = blogService.getBlogById(id);
    
    if (foundBlog && foundBlog.status === 'published') {
      setBlog(foundBlog);
    } else {
      navigate('/Blog'); // Redirect if blog not found
    }
    setLoading(false);
  };

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
          <p className="mt-4 text-gray-600">Loading blog post...</p>
        </div>
      </div>
    );
  }

  if (!blog) return null;

  return (
    <section className={`pb-20 flex flex-col items-center`}>
      <div className='relative w-full'>
        <div className="absolute z-10 left-10 items-center py-24">
          <button onClick={() => navigate('/Blog')} className="text-tertiary hover:text-tertiary font-semibold flex gap-2 items-center">
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
            </svg>
            Back to Blogs
          </button>
        </div>
        <img src={blog.image} alt={blog.title} className="relative w-full h-[600px] object-cover" />
      </div>
      
      <div className="flex flex-col items-start gap-6 p-10">
        <span className="py-4 text-second text-ss font-semibold">
          {blog.category}
        </span>

        <h1 className="text-md md:text-mm font-bold text-gray-800 mb-4">{blog.title}</h1>

        <div className="ml-2">
          <div className="flex items-center text-gray-500 text-ss">
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            {formatDate(blog.publishDate)}
          </div>
        </div>

        <div className="flex items-center mr-10 pt-8 border-t border-gray-200 max-w-[840px]">            
          <p className={`text-sm md:text-ss`}>{blog.content}</p>
        </div>

        {blog.updatedAt && blog.updatedAt !== blog.publishDate && (
          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-xs text-gray-500">Last updated: {formatDate(blog.updatedAt)}</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default BlogDetail